export default __webpack_public_path__ + "static/media/landing-3.e50d91d6.png";